
    module.exports = {
      render: function(){with(this){return _c('div',{attrs:{"id":"student-details"}},[_c('div',{staticClass:"historical-objective-scores"},[_c('h2',{staticClass:"objective-title"},[_v(_s(objective.name))]),_c('div',_l((recent_scores),function(score){return _c('historical_score_card',{key:score.id,attrs:{"score":score,"score_band":score_band,"score_colors_and_fills":score_colors_and_fills}})}),1)])])}},
      staticRenderFns: []
    };
  